import { apiService } from './apiService';

// Helper function to convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj) return obj;
  
  const camelObj = {};
  Object.keys(obj)?.forEach(key => {
    const camelKey = key?.replace(/_([a-z])/g, (g) => g?.[1]?.toUpperCase());
    camelObj[camelKey] = obj?.[key];
  });
  return camelObj;
};

// Helper function to convert camelCase to snake_case
const toSnakeCase = (obj) => {
  if (!obj) return obj;
  
  const snakeObj = {};
  Object.keys(obj)?.forEach(key => {
    const snakeKey = key?.replace(/[A-Z]/g, letter => `_${letter?.toLowerCase()}`);
    snakeObj[snakeKey] = obj?.[key];
  });
  return snakeObj;
};

export const categoryService = {
  // Get all categories
  async getAll(includeInactive = false) {
    try {
      const data = await apiService.getCategories();
      return data || [];
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // Get single category
  async getById(id) {
    try {
      const data = await apiService.getCategories();
      return data?.find(cat => cat.id === id) || null;
    } catch (error) {
      console.error('Error fetching category:', error);
      throw error;
    }
  },

  // Get category by slug
  async getBySlug(slug) {
    try {
      const data = await apiService.getCategories();
      return data?.find(cat => cat.slug === slug) || null;
    } catch (error) {
      console.error('Error fetching category by slug:', error);
      throw error;
    }
  },

  // Create new category - not available via HTTP API
  async create(categoryData) {
    try {
      throw new Error('Category creation not available via API. Use admin panel.');
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  // Update category - not available via HTTP API
  async update(id, categoryData) {
    try {
      throw new Error('Category update not available via API. Use admin panel.');
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },

  // Delete category - not available via HTTP API
  async delete(id) {
    try {
      throw new Error('Category deletion not available via API. Use admin panel.');
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  },

  // Subscribe to real-time changes - not available with HTTP API
  subscribeToChanges(callback) {
    console.warn('Real-time subscriptions are not supported with HTTP API');
    return () => {};
  }
};
